import React from 'react';

import { IconRegularPlus, IconRegularMinus } from '@notino/react-styleguide';

import { ReactFCV } from '@types';

import { IPlusMinusButtonProps, PlusMinusButtonType } from './model';
import { StyledPlusMinusButton } from './styled';

export const PlusMinusButton: ReactFCV<IPlusMinusButtonProps> = ({ onClick, disabled, symbol, ...rest }) => (
  <StyledPlusMinusButton data-testid="plus-minus-btn" onClick={onClick} disabled={disabled} {...rest}>
    {symbol === PlusMinusButtonType.PLUS ? (
      <IconRegularPlus
        data-testid="plus-icon"
        width="50%"
        height="50%"
        color={disabled ? 'icon.disabled' : 'icon.primary'}
      />
    ) : (
      <IconRegularMinus
        data-testid="minus-icon"
        width="50%"
        height="50%"
        color={disabled ? 'icon.disabled' : 'icon.primary'}
      />
    )}
  </StyledPlusMinusButton>
);
